import { reactive } from 'vue';

// Deploy sonrası açık kalan sekmede eski build'in artık sunucuda olmayan bir chunk dosyasını
// istemesi durumu — deploy-sync.ps1 yerelde olmayan uzak dosyaları sildiği için web.config
// eksik .js/.css'e index.html döner, webpack bunu ChunkLoadError olarak fırlatır. Paylaşılan
// durum baglanti.js (bağlantı kesintisi) ile aynı desen.
export const yeniSurumState = reactive({
  goster: false,
  hedef: null,
});

export function chunkHatasiMi(err) {
  return !!(err && (err.name === 'ChunkLoadError' || /Loading (CSS )?chunk \S+ failed/.test(err.message || '')));
}

// Eksik chunk'a sunucu 200 + index.html döndüğünde tarayıcı önce <script>'i HTML olarak
// ayrıştırmaya çalışır ve window 'error' olayı olarak SyntaxError ("Unexpected token '<'",
// Firefox'ta "expected expression, got '<'") fırlatır; ChunkLoadError ondan SONRA gelir. Bu
// SyntaxError kendi /js/*.js paketimizden geliyorsa aynı eski-sürüm durumudur (çağrı #3174).
export function eskiPaketHatasiMi(e) {
  if (!e) return false;
  const dosya = String(e.filename || '');
  const mesaj = String(e.message || '');
  return /\/js\/[^/]+\.js(\?|$)/.test(dosya) && /Unexpected token '<'|expected expression, got '<'/.test(mesaj);
}

export function yeniSurumUyarisiAc(hedef) {
  yeniSurumState.goster = true;
  if (hedef) yeniSurumState.hedef = hedef;
}

// OB1 (G-32): düz reload/assign tarayıcının önbellekteki eski index.html'ini getirebiliyordu
// (eski app.<hash>.js → yine eksik chunk → uyarı döngüsü). Adrese v=<zaman> eklenerek önbellek
// atlanır; mevcut sorgu parametreleri korunur.
export function yeniSurumYenile() {
  const url = new URL(yeniSurumState.hedef || window.location.href, window.location.href);
  url.searchParams.set('v', String(Date.now()));
  window.location.assign(url.toString());
}

// OB1: açılışta v parametresi adresten silinir. Bu modül router.js'ten önce değerlendirildiği
// için router ilk rotayı v'siz okur.
(function surumParamTemizle() {
  try {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('v')) return;
    url.searchParams.delete('v');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } catch (e) { /* eski tarayıcı: adreste kalır, zararsız */ }
})();
